var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15, _g, _path16, _path17, _path18, _path19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepositAlertDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "n1l5p1a7ka",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h120v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#n1l5p1a7ka)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.002.036v23.671M53.157 10.557l.064 32.344M76.98 39.666v15.412M81.165 46.703v15.412",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.207 16.689s3.824-2.388 5.181-2.735c1.358-.347 4.817-.23 7.589 1.415 2.77 1.645 4.91 3.705 7.878 7.579 2.968 3.873 4.746 8.468 5.44 11.52.944 4.15.423 7.866-.443 9.365-.867 1.5-4.997 4.428-4.997 4.428L59.207 16.688z",
    fill: "#2F353B",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m67 17 4-2M72 20l3.5-2M77 24.337 79.658 23M80.05 30.15l3.4-1.3M82.05 36.15l3.4-1.3M83.034 41.784l2.831-.91",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.419 26.683c2.84 4.375 4.387 8.981 4.604 12.88.218 3.912-.898 7.034-3.278 8.58-2.38 1.545-5.686 1.295-9.17-.495-3.474-1.785-7.053-5.07-9.895-9.445-2.84-4.375-4.386-8.98-4.604-12.88-.218-3.912.898-7.034 3.278-8.58 2.38-1.545 5.687-1.295 9.17.495 3.475 1.785 7.054 5.07 9.895 9.445z",
    fill: "#464C51",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.39 28.016c2.215 3.41 3.418 6.997 3.587 10.029.17 3.043-.7 5.45-2.527 6.636-1.827 1.186-4.38 1.002-7.09-.39-2.701-1.388-5.49-3.946-7.704-7.356-2.214-3.41-3.417-6.997-3.586-10.029-.17-3.043.7-5.45 2.527-6.636 1.828-1.186 4.38-1.002 7.09.39 2.702 1.388 5.49 3.946 7.704 7.356z",
    fill: "#5D6266",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.046 41.948s-.438-2.815 3.303-4.258c3.741-1.444 9.562-.133 12.972 1.638C48.731 41.1 89.476 64.38 89.476 64.38v49.278l-60.43-34.244V41.948z",
    fill: "#464C51",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m30.98 45.383 8.305-5.39 46.21 26.916v43.174l-9.997 5.267-43.945-67.064-.573-2.903z",
    fill: "#242A30",
    stroke: "#7E8285",
    strokeWidth: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.956 43.469 80.35 69.796v43.011",
    stroke: "#7E8285",
    strokeWidth: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m36.5 41.95 46.487 26.576v42.847",
    stroke: "#7E8285",
    strokeWidth: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.476 83.217 91 84.43l-1.524.829v-2.043z",
    fill: "#2F353B",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.046 41.95v50.962l47.671 27.089V71.534s-40.35-23.059-43.664-24.896c-3.313-1.837-4.007-4.689-4.007-4.689z",
    fill: "#5D6266",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M91 84.43v9.502l-14.283 8.482-7.696-4.53s-2.632-1.81-2.632-5.908c0-4.097 2.551-3.952 3.192-3.566.64.387 7.136 3.994 7.136 3.994L91 84.43z",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.717 92.404v10.01L91 93.932V84.43l-14.283 7.974z",
    fill: "#464C51",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.767,
    cy: 93.763,
    rx: 1.925,
    ry: 2.407,
    transform: "rotate(-47 70.767 93.763)",
    fill: "#BFC1C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "nnyozbahgb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 25,
    width: 37,
    height: 39
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m41.963 47.86-1.037-21.536 23.621-.357 12.17 15.566L75 54.5l-4.82 9.392L41.963 47.86z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nnyozbahgb)",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.974 30.444s3.823-2.387 5.18-2.734c1.358-.348 4.818-.23 7.59 1.415 2.77 1.645 4.91 3.705 7.877 7.579 2.969 3.873 4.746 8.468 5.44 11.519.945 4.15.423 7.866-.443 9.366s-4.996 4.428-4.996 4.428L46.974 30.444z",
    fill: "#2F353B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 30 4-2M59.5 33l3.083-2M65 39l3-1.5M68.55 44.242 71.5 43M70.5 50l2.762-.935M70.798 55.73 73.5 55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.186 40.44c2.84 4.374 4.386 8.98 4.604 12.88.218 3.91-.898 7.033-3.278 8.579-2.38 1.545-5.687 1.295-9.17-.495-3.475-1.785-7.054-5.07-9.895-9.445-2.84-4.375-4.387-8.981-4.604-12.88-.218-3.912.898-7.034 3.278-8.58 2.38-1.545 5.686-1.295 9.17.495 3.475 1.785 7.054 5.07 9.895 9.445z",
    fill: "#464C51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.157 41.772c2.215 3.41 3.418 6.997 3.587 10.029.17 3.043-.7 5.45-2.528 6.636-1.826 1.186-4.379 1.002-7.09-.39-2.7-1.388-5.489-3.946-7.703-7.356-2.214-3.41-3.417-6.997-3.586-10.029-.17-3.043.7-5.45 2.527-6.636 1.827-1.186 4.38-1.002 7.09.39 2.702 1.388 5.49 3.946 7.703 7.356z",
    fill: "#5D6266"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.316 76.416c1.761 3.61 2.389 7.331 1.996 10.421-.392 3.094-1.796 5.51-4.055 6.61-2.26 1.103-5.027.722-7.707-.873-2.676-1.593-5.222-4.38-6.983-7.989-1.76-3.61-2.388-7.331-1.996-10.421.393-3.094 1.797-5.51 4.056-6.61 2.259-1.103 5.026-.722 7.706.873 2.677 1.593 5.223 4.38 6.983 7.989z",
    fill: "#2F353B",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.117 88.22s.436.835.751 1.055c.316.22 1.105 0 1.105 0v-.826l-1.856-.228z",
    fill: "#000",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.935 83.825s.037 3.272.414 3.813c.377.542 2.86 2.076 3.27 1.83.412-.246.33-3.444.33-3.444s.07-1.453.65-1.826c.579-.373 1.882-1.594 2.028-2.998.147-1.404-.464-4.062-2.028-6.188-1.564-2.126-3.295-3.037-5.087-3.037-1.241 0-2.424 1.618-2.424 3.325 0 3.483 1.518 4.264 2.423 6.6.424 1.093.424 1.925.424 1.925z",
    fill: "#5D6266",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.935 83.826s.036 3.271.414 3.813c.377.542 2.859 2.076 3.27 1.83.411-.246.33-3.444.33-3.444l-4.014-2.199z",
    fill: "#2F353B",
    stroke: "#BFC1C2",
    strokeWidth: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositAlertDark);
export default __webpack_public_path__ + "static/media/deposit-alert-dark.c2ace1e7.svg";
export { ForwardRef as ReactComponent };